<ng-container *ngIf="!mode_sollicite">
  <app-avis-response-values [avis_obj]="avis_obj"></app-avis-response-values>
</ng-container>

<ng-container *ngIf="mode_sollicite">
  <ng-container *ngIf="mode_edition">
    <form [formGroup]="avisForm">
      <div>
        <mat-radio-group style="display:block;margin-top: 10px;" formControlName="avis">
          <mat-radio-button [value]="avisEnum.favorable" class="avis_item"
                            [class.horizontal]="true">
            {{avisEnum.toString(avisEnum.favorable)}}
          </mat-radio-button>
          <mat-radio-button [value]="avisEnum.unfavorable" class="avis_item"
                            [class.horizontal]="true">
            {{avisEnum.toString(avisEnum.unfavorable)}}
          </mat-radio-button>
          <mat-radio-button [value]="avisEnum.suspended_other" class="avis_item"
                            [class.horizontal]="true">
            {{avisEnum.toString(avisEnum.suspended_other)}}
          </mat-radio-button>
        </mat-radio-group>
      </div>
      <div>
        <mat-form-field appearance="outline" fxFlex="100">
          <mat-label>Observations</mat-label>
          <textarea type="text" rows="8"
                    formControlName="avis_observation"
                    matInput placeholder="" data-cy="txtarea-avis-observations"></textarea>
        </mat-form-field>
      </div>
      <button mat-raised-button type="button" color="primary"
              matTooltip="Enregistrer votre avis"
              (click)="sendAvis()"
              [disabled]="!avisForm.controls['avis'].value"
              data-cy="btn-send-avis">
        Enregistrer votre avis
      </button>
    </form>
  </ng-container>
  <ng-container *ngIf="!mode_edition">
    <app-avis-response-values [avis_obj]="avis_obj"></app-avis-response-values>
    <button mat-raised-button type="button" color="primary"
            matTooltip="modifier votre avis"
            (click)="changeMode()"
            data-cy="btn-send-avis">
      Modifier votre avis ?
    </button>
  </ng-container>
</ng-container>

